<template>
    <nav class="navigation">
        <ul class="menu menu-rsvp">
            <li><!--<router-link to="/rsvp">--><span @click="clickLink">RSVP</span><!--</router-link>--></li>
        </ul>

        <ul class="menu menu-left">
            <!--<li><router-link to="/">Index</router-link></li>-->
            <li><!--<router-link to="/schema">--><span @click="clickLink">Schema</span><!--</router-link>--></li>
            <li><!--<router-link to="/florens">--><span @click="clickLink">Florens</span><!--</router-link>--></li>
        </ul>

        <ul class="menu menu-center">
            <li><!--<router-link to="/rsvp">--><span @click="clickLink">RSVP</span><!--</router-link>--></li>
        </ul>

        <ul class=" menu menu-right">
            <li><!--<router-link to="/ceremoni">--><span @click="clickLink">Ceremoni</span><!--</router-link>--></li>
            <li><!--<router-link to="/middag">--><span @click="clickLink">Middag</span><!--</router-link>--></li>
        </ul>
    </nav>
</template>

<script>
import { setTimeout } from 'timers';
// import { setTimeout } from 'timers';

export default {
  data: function () {
    return {
      linkClickedC: false,
      clickEvent: {}
    };
  },

  mounted: function () {
    // ta reda på vilken sida som visas
    const thisView = this.$route.name;
    // console.log(thisView);
    // Leta reda på den li som innehåller länken och lägg till klassen current på dess li
    const liItems = Array.from(document.querySelectorAll('.navigation li'));

    liItems.forEach(element => {
      if (element.innerText.toLowerCase() === thisView) {
        element.classList.add('current');
      }
    });
  },

  methods: {

    goToView () {
      this.$router.push(this.clickEvent.target.innerText.toLowerCase());
      // console.log('sdfsdf');
    },

    // när man klickar på en länk
    clickLink (event) {
      // console.log('clicklink');
      // sätt variabeln isClicked till true, så att man kan lägga till klassen.
      // om man klickar på samma sida som man står på, gör inget
      this.clickEvent = event;

      if (this.$route.name !== this.clickEvent.target.innerText.toLowerCase()) {
        this.linkClickedC = true;
        this.$emit('link-clicked', true);
        // setTimeout(this.goToView, 1000);
        setTimeout(this.goToView, 500);
      }
    }
  }

};
</script>

